import FloatingVue from 'floating-vue'
import type { App, Plugin } from 'vue'

import { i18nVue, options } from './i18n'

export const registerPlugins = (app: App) => {
  app.use(i18nVue as Plugin, options)

  app.use(FloatingVue, {
    themes: {
      dropdown: {
        placement: 'bottom-end',
        distance: 10,
      },
      ['line-action']: {
        $extend: 'dropdown',
        placement: undefined,
      },
      ['tenant-switch']: {
        $extend: 'dropdown',
        distance: 8,
      },
    },
  })
}
